import { stringify as StringifyQS } from 'qs'
import { Browser } from '@capacitor/browser'

import emisorEventosObjeto from '../lib/emisorEventosObjeto'
import type { Monedas } from '@comun/zodComun'

const enfriandoCambioDeRutaRef = ref(false)

export const enfriandoCambioDeRuta = computed(() => unref(enfriandoCambioDeRutaRef))

const bus = { ...emisorEventosObjeto }
bus.on('rutaCambiada', ((para: string) => {
  consolo.log('rutaCambiada', 'para', para, 'bloqueado')
  enfriandoCambioDeRutaRef.value = true
  setTimeout(() => {
    consolo.log('rutaCambiada', 'para', para, 'liberado')
    enfriandoCambioDeRutaRef.value = false
  }, 400)
}) as (...args: unknown[]) => void)

export const colaURL = StringifyQS

export function urlAgregarQueryParams(url: string, datos: Record<string, string | number>) {
  const cola = StringifyQS(datos)
  const urlCompleta = `${url}?${cola}`
  return urlCompleta
}

export function monetizado(monto: number | string, moneda: Monedas = 'CLP') {
  monto = Number(monto)
  if (Number.isNaN(monto))
    return undefined

  if (monto === 0)
    return ' Gratis'

  if (!monto)
    return null

  if (monto <= 0)
    return 'ERRNEG'

  if (moneda === 'USD')
    monto = monto.toFixed(2)
  return monto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export function capitalizar(texto: string) {
  if (texto.length === 0)
    return ''
  const str = String(texto)
  return str.substring(0, 1).toUpperCase() + str.substring(1)
}

export function detectorToque(_event: TouchEvent) {
  // consolo.log('detectorToque', event)
}

// Esquemas que requieren abrir la app nativa en lugar del navegador in-app
const esquemasNativos = ['zoommtg:', 'zoomus:', 'tel:', 'mailto:', 'sms:', 'whatsapp:']

function esEsquemaNativo(url: string): boolean {
  return esquemasNativos.some(esquema => url.toLowerCase().startsWith(esquema))
}

// URLs HTTPS que necesitan el navegador del sistema (no in-app) para permitir
// redirección a apps nativas. Ej: Zoom HTTPS → app Zoom via esquema zoomus://
function requiereNavegadorDelSistema(url: string): boolean {
  const dominios = ['zoom.us', 'us02web.zoom.us', 'us04web.zoom.us', 'us05web.zoom.us', 'us06web.zoom.us']
  try {
    const parsed = new URL(url)
    return dominios.some(d => parsed.hostname === d || parsed.hostname.endsWith('.' + d))
  } catch { return false }
}

export function abrirEnNavegador(url: string) {
  console.log('[abrirEnNavegador] url=', url, 'esEsquemaNativo=', esEsquemaNativo(url), 'requiereNavegadorDelSistema=', requiereNavegadorDelSistema(url))

  const ventanaObservable = {
    ...emisorEventosObjeto
  }

  // Si es un esquema nativo (zoom, tel, etc) o una URL que requiere el navegador del sistema
  // (ej: Zoom HTTPS en iOS donde SFSafariViewController no puede redirigir a apps nativas)
  if (esEsquemaNativo(url) || requiereNavegadorDelSistema(url)) {
    console.log('[abrirEnNavegador] ruta: esquema nativo o sistema')
    new Promise(resolve => setTimeout(resolve, 50))
      .then(() => {
        window.open(url, '_system')
        // Emitir eventos para mantener consistencia
        ventanaObservable.emit('cargada')
        setTimeout(() => ventanaObservable.emit('cerrada'), 100)
      })
    return ventanaObservable
  }

  // Para URLs http/https, usar el navegador in-app de Capacitor
  console.log('[abrirEnNavegador] ruta: Capacitor Browser.open')

  const usarCapacitorBrowser = typeof Browser !== 'undefined' && Browser.open
  console.log('[abrirEnNavegador] Browser disponible=', usarCapacitorBrowser)

  if (!usarCapacitorBrowser) {
    console.warn('[abrirEnNavegador] Browser no disponible, usando window.open inmediato')
    window.open(url, '_blank')
    ventanaObservable.emit('cargada')
    setTimeout(() => ventanaObservable.emit('cerrada'), 100)
    return ventanaObservable
  }

  try {
    Browser.addListener('browserPageLoaded', () => {
      console.log('[abrirEnNavegador] browserPageLoaded')
      ventanaObservable.emit('cargada')
    })
    Browser.addListener('browserFinished', () => {
      console.log('[abrirEnNavegador] browserFinished')
      ventanaObservable.emit('cerrada')
      Browser.removeAllListeners()
    })
  }
  catch (err) {
    console.error('[abrirEnNavegador] ERROR al registrar listeners de Browser:', err)
  }

  console.log('[abrirEnNavegador] llamando Browser.open')
  try {
    Browser.open({ url, presentationStyle: 'fullscreen' })
  }
  catch (err) {
    console.error('[abrirEnNavegador] ERROR sincrono en Browser.open, fallback a window.open:', err)
    window.open(url, '_blank')
    ventanaObservable.emit('cargada')
    setTimeout(() => ventanaObservable.emit('cerrada'), 100)
  }

  return ventanaObservable
}

export async function proximoFrame() { return new Promise(requestAnimationFrame) }

export async function esperar(ms: number) { return new Promise(resolve => setTimeout(resolve, ms)) }